<template>
  <div id="app">
    <v-app>
      <v-app-bar
        color="white"
        app
        left
        elevation="3"
        :clipped-left="true"
        :extension-height="isAuthenticated() ? 300 : 200"
        :class="{ desktop: !topnavBreakpoint, mobile: topnavBreakpoint }"
      >
        <v-row>
          <v-col class="topnav-col" cols="5" sm="4" lg="3" xl="2">
            <v-app-bar-nav-icon
              v-if="isAuthenticated()"
              class="mr-4"
              @click="headerToggleClick"
            />
            <v-img
              alt="vdi tz logo"
              class="img-logo mb-4"
              :src="require('@/assets/img/vdi-tz-logo.jpg')"
              max-height="64"
            />
          </v-col>

          <v-col>
            <v-toolbar-title> Ergebnismonitoring Tool </v-toolbar-title>
          </v-col>

          <v-col v-if="isAuthenticated()" cols="4" sm="3" lg="2" xl="2">
            <TokenTimeoutCountdown
                class="timeout-countdown"
                @showTokenRefreshMeldung="showLogoutMessage()"
            />
          </v-col>

          <v-col cols="4" sm="1" lg="1" xl="1">
            <b-btn v-if="isAuthenticated()" @click="zeigeProfil()">Profil</b-btn>
          </v-col>

          <v-col cols="4" sm="3" lg="2" xl="1" class="pt-0">
            <v-img
              alt="bmbf beauftragte logo"
              class="img-logo"
              :src="require('@/assets/img/bmbf-beauftragte-logo.png')"
              contain
              max-height="64"
            />
          </v-col>
        </v-row>
      </v-app-bar>

      <v-navigation-drawer
        v-if="isAuthenticated()"
        v-model="drawer"
        :mini-variant="mini"
        :clipped="true"
        permanent
        app
        class="sidebar"
      >
        <v-list dense>
          <v-list-item key="projectSight" link :to="'/projekt'">
            <v-list-item-icon>
              <v-icon>mdi-folder</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Projekt</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item key="auswertungen" link :to="'/auswertungen'">
            <v-list-item-icon>
              <v-icon>mdi-chart-line</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Auswertungen</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group no-action prepend-icon="mdi-settings" v-if="isAdmin()">
            <template v-slot:activator>
              <v-list-item-title><h3>Einstellungen</h3></v-list-item-title>
            </template>
            <v-list-item link :to="`/templates`">
              <v-list-item-icon>
                <v-icon>mdi-file-question</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Templates</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="'/datenimport'">
              <v-list-item-icon>
                <v-icon>mdi-upload</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Profi-Import</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="`/mitarbeiter`">
              <v-list-item-icon>
                <v-icon>mdi-account-group</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Mitarbeiter</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item @click="logout" v-if="isAuthenticated()">
            <v-list-item-icon>
              <v-icon>mdi-power</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-main>
        <v-container fluid>
          <div class="router-content">
            <router-view />
          </div>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
// import { isAuthenticated, logout } from '@/auth';
import dataMixin from '@/mixins/data-mixin';
import { mapGetters, mapMutations } from 'vuex';
import { isAuthenticated } from '@/auth';
import { logout as _logout } from '@/auth';
import TokenTimeoutCountdown from './components/TokenTimeoutCountdown';
import store from '@/store';

export default {
  name: 'app',
  components: {
    TokenTimeoutCountdown,
  },
  data() {
    return {
      drawer: true,
      mini: false,
      topNavExtend: false,
    };
  },
  mixins: [dataMixin('formIsDirty', 'transientData.formIsDirty')],
  computed: {
    ...mapGetters('userData', ['getUserData']),
    topnavBreakpoint() {
      return (
        this.$vuetify.breakpoint.xs ||
        this.$vuetify.breakpoint.sm ||
        this.$vuetify.breakpoint.md
      );
    },
  },
  methods: {
    ...mapMutations('userData', ['setUserData']),
    ...mapMutations('userData', ['resetUserData']),
    headerToggleClick() {
      this.mini = !this.mini;
    },
    isAuthenticated() {
      return isAuthenticated();
    },
    logout() {
      this.forceLogout();
    },
    forceLogout() {
      _logout();
      this.resetUserData();
      // this.resetNavigationData();
      this.$router.push('/login');
      store.dispatch('configuration/resetStore');
    },
    zurStartseite() {
      this.$router.push('/home');
    },
    isAdmin() {
      return this.getUserData.rolle === 'ADMINISTRATOR';
    },
    zeigeProfil() {
      this.$router.push('/profil');
    },
    showLogoutMessage() {
      this.showTokenRefreshPopup = true;
    },
  },
};
</script>

<style lang="scss">
// Topnav
.v-toolbar__content {
  .row,
  .topnav-col {
    height: inherit;
  }
  .topnav-col {
    display: flex;
    align-items: center;

    &.token-timeout-wrapper,
    &.topnav-dots,
    &.url-col {
      justify-content: flex-end;
    }

    &.url-col {
      justify-content: start;
    }
    &.url-col.notAuthenticated {
      justify-content: flex-end;
    }

    .timeout-countdown {
      padding-right: 20px;
    }

    &.time-user-wrapper {
      justify-content: flex-end;
    }
  }

  .v-toolbar__title {
    text-align: center;
    font-size: 1.8rem;
  }
}
.v-toolbar__extension .container {
  margin: 0;
  padding-left: 7px;
}

h1,
h2,
h3 {
  margin: 0;
  padding: 0;
}

.separator {
  width: 1px;
  height: 80%;
  background-color: rgba(0, 0, 0, 0.87);
}

.user-action-wrapper {
  .v-expansion-panel--active {
    top: 60px;
  }
  .v-expansion-panel-header {
    padding: 0 0 0 20px;
  }
  span {
    font-size: 12px;
    display: block;
  }
  .item .user-actions {
    padding-left: 0;
    .v-btn__content {
      text-align: left;
    }
  }
}

.v-application {
  .sidebar.v-navigation-drawer {
    background: #403f56;

    .v-list {
      padding: 0;

      .v-list-item {
        padding: 0;
        min-height: 68px;
        color: #fff !important;
        border-left: 5px solid #403f56;

        &.v-list-item--active {
          background: #39394d;
          color: #ffff !important;
          border-color: #ffff;
          .v-list-item__title {
            font-weight: bold;
            font-size: 1.17rem;
          }
          .v-list-item__icon {
            .v-icon {
              color: #ffff;
            }
          }
        }

        .v-list-item__icon {
          padding: 26px 16px;
          margin-right: 0;
          .v-icon {
            color: #fff;
          }
        }
        .v-list-item__title {
          font-size: 1rem;
          h3 {
            font-size: 1rem;
            font-weight: normal;
            margin-left: 11px;
          }
        }
      }

      .v-list-group {
        & > .v-list-item--active {
          background: #39394d;
          color: #ffff !important;
          border: none;
        }

        .v-list-group__items {
          .v-list-item {
            color: rgba(0, 0, 0, 0.87);
            padding-left: 25px;

            .v-list-item__title {
              text-transform: none;
              padding: 22px 0;
            }

            &.v-list-item--active {
              background: #39394d;
              color: #ffff !important;
            }
          }
        }
      }
    }
  }
}

.v-main {
  .v-main__wrap {
    background: #eee;
    padding: 15px;
    .router-content {
      margin-bottom: 100px;
      background: #fff;
      padding: 25px 40px;
      min-height: 400px;

      .error--text {
        color: #ff0000 !important;
        caret-color: #ff0000 !important;
      }
    }
  }
}

.alert {
  position: absolute;
  z-index: 900;
  width: 400px;
  top: 80px;
  right: 5px;
}
</style>

